import React, { useState, useEffect } from "react";
import { activateUser, getUserDetailsInfo, updateUserData } from "../API";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "./Loader";
import ArrowLeft from "../assets/images/left-arrow.png";
import { toast } from "react-toastify";
import SaveIcon from "../assets/images/correct.png";
import EditIcon from "../assets/images/edit_icon.png";
import DeleteIcon from "../assets/images/remove_icon.png";
import "../assets/styles/users.scss";

const UserDetails = () => {
  const [projectDetails, setProjectDetails] = useState();
  const [crewId, setCrewId] = useState("");
  const [toggelCrewId, setToggleCrewId] = useState(false);
  const [secondaryEmail, setSecondaryEmail] = useState("");
  const [toggleEmail, setToggleEmail] = useState(false);
  const [loginAccess, setLoginAccess] = useState(false);
  const [adminAccess, setAdminAccess] = useState(false);
  const [checklistApproverAccess, setChecklistApproverAccess] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const param = useParams();


  const toggleAllowAccess = async (e) => {
    const isAccess = e?.target?.checked;
    const payload = {
      is_login: isAccess,
    };
    await updateUserData(projectDetails?.id, payload).then((res) => {
      return
    });
  };

  const toggleAllowAdminAccess = async (e) => {
    const isAccess = e?.target?.checked;
    const payload = {
      role_id: isAccess ? 1 : 2,
    };
    await updateUserData(projectDetails?.id, payload).then((res) => {
      return
    });
  };

  const toggleChecklistApprover = async (e) => {
    const isAccess = e?.target?.checked;
    const payload = {
      checklist_approver: isAccess,
    };
    await updateUserData(projectDetails?.id, payload).then((res) => {
      return
    });
  };

  const onClickCancel = () => {
    setCrewId("");
    setToggleCrewId(false);
  };

  const onEmailCancel = () => {
    setSecondaryEmail("");
    setToggleEmail(false);
  };

  const fetchProjectDetails = async () => {
    try {
      const res = await getUserDetailsInfo(param?.id);
      if (res.status === 200) {
        res?.data?.role_id === 1 ? setAdminAccess(true) : setAdminAccess(false);
        setLoginAccess(res?.data?.is_login);
        setChecklistApproverAccess(res?.data?.checklist_approver);
        setProjectDetails(res?.data);
        setLoading(false);
      }
    } catch (err) {
      console.log("Error occurred in getUserDetailsInfo", err);
    }
  };

  const onClickSave = async () => {
    const payload = {
      crew_id: crewId,
    };
    if (projectDetails?.crew_id === crewId) {
      setToggleCrewId((prevState) => !prevState);
      setCrewId("");
      toast.warn("Same Crew Id");
    } else {
      await updateUserData(projectDetails?.id, payload).then((res) => {
        toast.success("Crew id updated");
        fetchProjectDetails();
        setToggleCrewId((prevState) => !prevState);
        setCrewId("");
      });
    }
  };

  const onClickEmailSave = async () => {
    const payload = {
      secondary_email: secondaryEmail,
    };
    if (projectDetails?.secondary_email === secondaryEmail) {
      setToggleEmail((prevState) => !prevState);
      setSecondaryEmail("");
      toast.warn("Same email");
    } else {
      await updateUserData(projectDetails?.id, payload).then((res) => {
        if (res?.status === 200) {
          toast.success("Secondary email updated");
        } else if (res?.status === 422) {
          toast.error("Invalid email");
        }
        fetchProjectDetails();
        setToggleEmail((prevState) => !prevState);
        setSecondaryEmail("");
      });
    }
  };

  const onClickEdit = () => {
    setToggleCrewId((prevState) => !prevState);
    setCrewId(projectDetails?.crew_id);
  };

  const onClickEditEmail = () => {
    setToggleEmail((prevState) => !prevState);
    setSecondaryEmail(projectDetails?.secondary_email);
  };

  const onChangeCrewId = (e) => {
    setCrewId(e.target.value);
  };

  const onChangeEmail = (e) => {
    setSecondaryEmail(e.target.value.trim());
  };

  const onClickActivate = async () => {
    const payload = {
      id: projectDetails?.id,
    };
    await activateUser(payload).then((res) => {
      toast.success("Activation details are sent to your email");
    });
  };

  useEffect(() => {
    fetchProjectDetails();
  }, []);

  const formattedCreatedAt = projectDetails?.created_at
    ? new Date(projectDetails.created_at).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      })
    : "NA";

  const statusLabel = projectDetails?.status || "Inactive";

  return (
    <div className="user-details-page">
      {loading ? (
        <Loader />
      ) : (
        <div className="user-details-layout">
          <div className="details-header">
            <button
              className="btn btn-primary back-btn details-back"
              onClick={() => navigate(-1)}
            >
              <img src={ArrowLeft} alt="" />
            </button>
            <button className="back-link" onClick={() => navigate(-1)}>
              Back to Users
            </button>
          </div>

          <div className="details-topbar">
            <div>
              <h2 className="title">User Details</h2>
              <p className="details-subtitle">
                Manage profile information and system access
              </p>
            </div>
            <div className="details-meta">
              <span className="status-chip">
                <span className="status-dot" />
                {statusLabel}
              </span>
              <span className="created-date">Added {formattedCreatedAt}</span>
            </div>
          </div>

          <div className="details-card">
            <div className="details-panel profile-panel">
              <div className="panel-heading">Profile Information</div>

              <div className="info-row">
                <span className="label">Name</span>
                <span className="value">{projectDetails?.name}</span>
              </div>

              <div className="info-row">
                <span className="label">Employee id</span>
                <span className="value">
                  {projectDetails?.employee_id ? projectDetails?.employee_id : "NA"}
                </span>
              </div>

              <div className="info-row editable-row">
                <span className="label">Crew id</span>
                <div className="value editable-value">
                  {toggelCrewId ? (
                    <input
                      disabled={!toggelCrewId}
                      value={crewId}
                      defaultValue={projectDetails?.crew_id}
                      autoComplete="off"
                      name="name"
                      type="text"
                      className="time-picker-container input-with-icons"
                      onChange={(e) => onChangeCrewId(e)}
                    />
                  ) : (
                    <span className="plain-edit-value">
                      {projectDetails?.crew_id ? projectDetails?.crew_id : "NA"}
                    </span>
                  )}
                  <div className="inline-actions">
                    {toggelCrewId ? (
                      <>
                        <img
                          onClick={() => onClickSave()}
                          className="correct-logo"
                          src={SaveIcon}
                          alt=""
                        />
                        <img
                          className="correct-logo"
                          onClick={() => onClickCancel()}
                          src={DeleteIcon}
                          alt=""
                        />
                      </>
                    ) : (
                      <img
                        onClick={() => onClickEdit()}
                        className="edit-logo"
                        src={EditIcon}
                        alt=""
                      />
                    )}
                  </div>
                </div>
              </div>

              <div className="info-row">
                <span className="label">Email</span>
                <span className="value">{projectDetails?.email}</span>
              </div>

              <div className="info-row editable-row">
                <span className="label">Secondary email</span>
                <div className="value editable-value">
                  {toggleEmail ? (
                    <input
                      value={secondaryEmail}
                      defaultValue={projectDetails?.secondary_email}
                      autoComplete="off"
                      name="name"
                      type="text"
                      className="time-picker-container input-with-icons"
                      onChange={(e) => onChangeEmail(e)}
                    />
                  ) : (
                    <span className="plain-edit-value">
                      {projectDetails?.secondary_email
                        ? projectDetails?.secondary_email
                        : "NA"}
                    </span>
                  )}
                  <div className="inline-actions">
                    {toggleEmail ? (
                      <>
                        <img
                          onClick={() => onClickEmailSave()}
                          className="correct-logo"
                          src={SaveIcon}
                          alt=""
                        />
                        <img
                          className="correct-logo"
                          onClick={() => onEmailCancel()}
                          src={DeleteIcon}
                          alt=""
                        />
                      </>
                    ) : (
                      <img
                        onClick={() => onClickEditEmail()}
                        className="edit-logo"
                        src={EditIcon}
                        alt=""
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="details-panel access-panel">
              <div className="panel-heading">System Access</div>

              <div className="access-block">
                <div className="access-copy">
                  <h4>User Login</h4>
                  <p>Can authenticate to web portal</p>
                </div>
                <div className="form-check form-switch">
                  <input
                    className="form-check-input toggle-switch"
                    type="checkbox"
                    role="switch"
                    defaultChecked={loginAccess}
                    onChange={(e) => toggleAllowAccess(e)}
                  />
                </div>
              </div>

              <div className="access-block">
                <div className="access-copy">
                  <h4>Admin Privileges</h4>
                  <p>Grant full system access</p>
                </div>
                <div className="form-check form-switch">
                  <input
                    className="form-check-input toggle-switch"
                    type="checkbox"
                    role="switch"
                    defaultChecked={adminAccess}
                    onChange={(e) => toggleAllowAdminAccess(e)}
                  />
                </div>
              </div>

              <div className="access-block">
                <div className="access-copy">
                  <h4>Checklist Approver</h4>
                  <p>Can review & approve project checklist</p>
                </div>
                <div className="form-check form-switch">
                  <input
                    className="form-check-input toggle-switch"
                    type="checkbox"
                    role="switch"
                    defaultChecked={checklistApproverAccess}
                    onChange={(e) => toggleChecklistApprover(e)}
                  />
                </div>
              </div>

              <div className="activation-block">
                <h4>Activation Status</h4>
                <p>
                  User has not yet activated their account. Resend the activation
                  link to their primary email.
                </p>
                <button className="activation-btn" onClick={() => onClickActivate()}>
                  Resend Activation Email
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserDetails;
